export const DEFAULT_LIST_RANGE_VALUE = 20;
export const FILTERING_LOADING_LABEL = 'Searching';
export const GENERAL_LOADING_LABEL = 'Retrieving the information';
export const SECONDARY_LOADING_LABEL = 'Wait a moment';
export const DEFAULT_HEIGHT = 650;
export const DELTA_HEIGHT = 45;
export const DELTA_ROW_HEIGHT = 62;
export const NO_MORE_DATA_DISPLAY_LABEL = 'No more Data to display';
export const LOADING = 'Loading...';
